var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BarChart',{attrs:{"chartId":_vm.selectedChart,"chartData":_vm.chartData,"chartSelection":_vm.chartSelection,"radioGroup":_vm.radioGroup},on:{"setSelection":function($event){_vm.chartSelection = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }